import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Box, Button, Tooltip } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MuiAlert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Technology(props) {
  const { state, onState, handleNext, classes, lablist } = props;
  const [temporary, settemporary] = useState([]);
  const [find, setfind] = useState(false); // This will now also handle the hyphen check
  const [numberfind, setnumberfind] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const handleReload = () => {
    window.location.reload();
  };

  const preventInvalidKeyInput = (e) => {
    // Block +, -, e, E, . (for number input)
    if (['+', '-', 'e', 'E', '.'].includes(e.key)) {
      e.preventDefault();
    }
    
    // Prevent entering more digits if already at max
    if (e.target.value.length >= 2 && e.key !== 'Backspace' && e.key !== 'Delete') {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    setnumberfind(false);
    const inputValue = e.target.value;

    if (/^[0-9]*$/.test(inputValue)) {
      const numericValue = parseInt(inputValue, 10);
      if (numericValue > 50 || numericValue <= 0 || isNaN(numericValue)) {
        setnumberfind(true);
      } else {
        const { id } = e.target;
        onState((prevState) => ({
          ...prevState,
          [id]: numericValue,
        }));
        settemporary((prevState) => ({
          ...prevState,
          [id]: numericValue,
        }));
      }
    } else {
      setnumberfind(true);
    }
  };

  const handleLabNameChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setfind(false); // Reset find state at the start of the change event

    // Check if the name starts with a hyphen
    if (value.startsWith('-')) {
      setfind(true);
      onState((prevState) => ({ ...prevState, [id]: value })); // Still update state
      settemporary((prevState) => ({ ...prevState, [id]: value })); // Still update temporary state
      return; // Exit early to prevent further checks
    }

    // Check if the lab name already exists
    const labExists = lablist.some((instance) => instance.name === value);
    if (labExists) {
      setfind(true);
    }

    onState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleDescriptionChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    onState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === '_') {
      event.preventDefault();
    }
  };

  useEffect(() => {
    setShowAlert(temporary.name && !/^[a-z0-9_-]{1,15}$/.test(temporary.name));
  }, [temporary.name]);

  const isNextButtonDisabled = !(
    temporary.name &&
    temporary.nooftrainee &&
    !find &&
    !showAlert &&
    !numberfind
  );

  return (
    <React.Fragment>
      <Box sx={{ pb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Create Lab
        </Typography>
      </Box>
      {showAlert && (
        <Box sx={{ pb: 2 }}>
          <Alert severity="warning">
            Please enter lowercase letters and only up to 15 characters.
          </Alert>
        </Box>
      )}

      <Grid container spacing={4}>
        <Grid item md={6} xs={12}>
          <InputLabel>
            Name<small style={{ paddingLeft: "10px" }}>required</small>
            <small style={{ color: "red" }}>*</small>
          </InputLabel>
          <TextField
            fullWidth
            helperText={
              temporary.name && temporary.name.startsWith('-')
                ? "Name cannot start with a hyphen"
                : find
                ? "Lab name already exists, Please enter a unique name"
                : "Please specify the name"
            }
            error={find}
            name="name"
            id="name"
            color={temporary.name && !find ? "success" : ""}
            onChange={handleLabNameChange}
            onKeyPress={handleKeyPress}
            required
            autoComplete="name"
            InputProps={{
              style: {
                height: "40px",
              },
            }}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <InputLabel>
            Number of Trainees
            <small style={{ paddingLeft: "10px" }}>required</small>
            <small style={{ color: "red" }}>*</small>
          </InputLabel>
          <TextField
            fullWidth
            helperText={
              numberfind
                ? "Please enter a value less than or equal to (50)"
                : "Please specify the number"
            }
            error={numberfind}
            name="nooftrainee"
            id="nooftrainee"
            onChange={handleChange}
            onKeyDown={preventInvalidKeyInput}
            required
            autoComplete="nooftrainee"
            type="number"
            inputProps={{ min: "1", max: "50", step: "1" }}
            InputProps={{
              style: {
                height: "40px",
              },
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <InputLabel>
            Description<small style={{ paddingLeft: "10px" }}>(optional)</small>
          </InputLabel>
          <TextField
            fullWidth
            name="description"
            id="description"
            onChange={handleDescriptionChange}
            autoComplete="family-name"
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <div>
          <Tooltip title="Cancel and reset this step"><span>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleReload}
            className={classes}
            sx={{ borderRadius: '50px' }}
          >
            Cancel
          </Button>
          </span></Tooltip>
        </div>

        <div>
          <Tooltip title={isNextButtonDisabled ? "Please complete required fields" : "Proceed to the next step"}><span>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            className={classes}
            disabled={isNextButtonDisabled}
            sx={{ borderRadius: '50px' }}
          >
            Next
          </Button>
          </span></Tooltip>
        </div>
      </Box>
    </React.Fragment>
  );
}